import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { getUnreadCount } from '../api/notifications';
import { useTranslation } from '../i18n';
import { BellIcon } from '../assets/icons';
import '../styles/NotificationBell.css';

const NotificationBell = () => {
    const history = useHistory();
    const location = useLocation();
    const { t } = useTranslation();
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        let cancelled = false;

        const fetchUnread = async () => {
            try {
                const data = await getUnreadCount();
                if (!cancelled) {
                    setUnreadCount(data.unread_count || 0);
                }
            } catch (err) {
                // silently ignore
            }
        };

        fetchUnread();
        window.addEventListener('notificationsUpdated', fetchUnread);
        return () => {
            cancelled = true;
            window.removeEventListener('notificationsUpdated', fetchUnread);
        };
    }, [location.pathname]);

    const ariaLabel = unreadCount > 0
        ? t('notifications.bell.labelUnread', { count: unreadCount })
        : t('notifications.bell.label');

    return (
        <button
            className="notif-bell"
            onClick={() => history.push('/notifications')}
            aria-label={ariaLabel}
        >
            <span className="notif-bell-icon">
                <BellIcon />
                {unreadCount > 0 && (
                    <span className="notif-bell-badge">
                        {unreadCount > 99 ? '99+' : unreadCount}
                    </span>
                )}
            </span>
        </button>
    );
};

export default NotificationBell;
